module.exports = __webpack_public_path__ + "static/media/ic_wap_2.8fa71e5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/activitySu/ic_wap_2.svg
// module id = 247
// module chunks = 0